import { render } from "./App.vue?vue&type=template&id=38a7681c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=38a7681c&lang=css"
script.render = render

export default script